/**
 * Markdown cleanup helpers.
 *
 * Exporters that go HTML->markdown (Trilium, Notion, Evernote via turndown)
 * defensively escape punctuation: "1\." "\-" "\[" etc. Inside a real
 * markdown editor those backslashes are visual noise, so imports strip
 * them. Code (fenced blocks and inline spans) is never touched.
 */
const ESCAPABLE = new Set([...'\\`*_{}[]()#+-.!|<>~"\'']);
function unescapeSegment(text) {
    let out = "";
    for (let i = 0; i < text.length; i++) {
        if (text[i] === "\\" && i + 1 < text.length && ESCAPABLE.has(text[i + 1])) {
            out += text[i + 1];
            i++;
        }
        else {
            out += text[i];
        }
    }
    return out;
}
/** Unescape a single line, skipping inline `code spans`. */
function unescapeLine(line) {
    const parts = line.split("`");
    // even indexes are outside code spans, odd are inside
    return parts.map((part, idx) => (idx % 2 === 0 ? unescapeSegment(part) : part)).join("`");
}
export function stripMarkdownEscapes(markdown) {
    const lines = markdown.split("\n");
    let inFence = false;
    const out = lines.map((line) => {
        if (/^\s*(```|~~~)/.test(line)) {
            inFence = !inFence;
            return line;
        }
        return inFence ? line : unescapeLine(line);
    });
    return out.join("\n");
}
//# sourceMappingURL=markdown.js.map